import { render, staticRenderFns } from "./DetailsPassengerItem.vue?vue&type=template&id=03010c0c&"
import script from "./DetailsPassengerItem.vue?vue&type=script&lang=ts&"
export * from "./DetailsPassengerItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports